<template>
  <div class="footergroup_main" :style="{ 'color': webID == '111144' ? sanNongCss :'' }">
    <!-- 此处为高能所改变了obj.title -->
    <div class="footergroup_top">
      <h1>{{isGaonS?(isEnglish&&((obj.title||'').indexOf('*##*')!=-1)?(obj.title||'').split('*##*')[1]:(obj.title||'').split('*##*')[0]):obj.title}}</h1>
    </div>
    <div class="footergroup_bottom">
      <!-- 此处为高能所改变了item.title -->
      <ul>
        <li
          v-for="(item,index) in obj.list"
          :key="index"
          @click="goPage(item)"
          :style="{ 'color': webID == '111144' ? sanNongCss :'' }"
        >{{isGaonS?(isEnglish&&((item.title||'').indexOf('*##*')!=-1)?(item.title||'').split('*##*')[1]:(item.title||'').split('*##*')[0]):item.title}}</li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return { sanNongCss: "#000000" };
  },
  props: ["obj"],
  methods: {
    goPage(item) {
      // let routeData = this.$router.resolve({
      //   path: item.url,
      // });
      window.open(item.url, "_blank");
    }
  },
  computed: {
    ...mapGetters(["isGaonS", "isEnglish", "webID"])
  }
};
</script>
<style lang="less">
.footergroup_main {
  color: #adadad;
  .footergroup_top {
    margin-bottom: 15px;
    font-weight: bold;
    font-size: 13px;
  }
  .footergroup_bottom {
    ul {
      li {
        margin-bottom: 1px;
        cursor: pointer;
        margin-bottom: 5px;
        color: rgba(255, 255, 255, 0.3);
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/footerGroup.vue